module.exports = __webpack_public_path__ + "img/app_coaches_top@3x.c8a59103.jpg";